import emptyHeadshot from "../../../assets/images&icons/emptyheadshot.jpg";

function ProfilePlaceholderIcon() {
  return (
    <img
      src={emptyHeadshot}
      alt=""
      className="h-full w-full object-cover"
      draggable={false}
    />
  );
}

export default ProfilePlaceholderIcon;
